export default "__VITE_ASSET__CgK94Gyb__"